import React, { useState } from "react";
import { Box, Modal, Slide } from "@mui/material";
import CheckWithDateMobileV2 from "../CheckWithDateMobileV2";
import ViewButtonMobileV2 from "../Buttons/ViewButtonMobileV2";
import AddButtonRoundMobileV4 from "../Buttons/AddButtonRoundMobileV4";
import ViewConfidentialityPolicyMobileV2 from "../forms/ViewConfidentialityPolicyMobileV2";

function FormLineCPMobileV2(props) {
  const [showViewModal, setShowViewModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };
  console.log("showViewModal:", showViewModal);

  return (
    <div
      style={{
        marginLeft: "0px",
        display: "flex",
        flexDirection: "row",
        height: "30px",
        borderRadius: "30px",
        border: "1px solid lightgrey",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        paddingLeft: "15px",
        paddingRight: "5px",
      }}
    >
      <Modal open={showViewModal} onClose={closeViewModal}>
        <Slide direction="left" in={showViewModal}>
          <Box
            sx={{
              position: "fixed",
              top: "5%",
              right: 0,
              width: "90%",
              height: "90%",
              bgcolor: "background.paper",
              boxShadow: 24,
              marginRight: "15px",
              pl: 0,
              pr: 0,
              borderRadius: "15px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ViewConfidentialityPolicyMobileV2
              {...props}
              closemodal={closeViewModal}
            />
          </Box>
        </Slide>
      </Modal>
      <div
        style={{
          width: "50%",
          fontSize: "13px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        {props.title}
      </div>
      <div
        style={{
          width: "35%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {props.signed ? (
          <CheckWithDateMobileV2 checked={true} content={props.date} />
        ) : (
          <CheckWithDateMobileV2 checked={false} content="Not signed" />
        )}
      </div>

      <div
        style={{
          width: "15%",
          display: "flex",
          justifyContent: "flex-end",
          alignContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {props.signed ? (
          <ViewButtonMobileV2 handleOpen2={openViewModal} {...props} />
        ) : (
          <AddButtonRoundMobileV4 handleOpen={props.handleOpen} />
        )}
      </div>
    </div>
  );
}

export default FormLineCPMobileV2;
